<template>
  <div class="dialog-wrapper" @touchmove.stop.prevent>
    <div class="dialog-mask"></div>
    <div class="dialog-box">
      <div class="login-title">
        <span v-if="!getIsApp">用户登录</span>
        <div class="appTitle" v-if="getIsApp">
          <div class="subTitle">绑定手机号</div>
          <div class="tip">还差一步即可注册成功</div>
        </div>
        <i class="iconfont icon-close" @click="close"></i>
      </div>
      <div class="login-input">
        <div class="itemBox">
          <div class="login-input-item">
            <i class="iconfont icon-shouji"></i>
            <input v-model="phoneNumber" type="text" maxlength="11" placeholder="请输入手机号" @keyup="limitInput('phone')" @blur="limitInput('phone', 'blur')" />
            <i class="input-clear iconfont icon-LogonClosed" v-show="phoneNumber.length > 0" @click="clearInput('phone')"></i>
            <span
              :class="{
                'time-tip-btn': true,
                cancel: countDownTime || phoneNumber.length <= 0
              }"
              @click="getValidateCode"
              >{{ validataCodeTxt }}</span
            >
          </div>
          <div class="login-input-item">
            <i class="iconfont icon-tubiaozhizuomoban"></i>
            <input v-model="codeNumber" class="code-input" type="text" maxlength="6" placeholder="请输6位验证码" @keyup="limitInput('code')" @blur="limitInput('code', 'blur')" />
            <i class="input-clear iconfont icon-LogonClosed" v-show="codeNumber.length > 0" @click="clearInput('code')"></i>
          </div>
        </div>
        <div class="loginDialogBottomPart">
          <div class="login-btn" @click="login" :class="{ isLoading: isLoading || !isAgree }" v-text="getIsApp ? '确定绑定' : '立即登录'"></div>
          <!-- 协议部分 -->
          <div class="agreementPart">
            <div class="con">
              <i class="iconfont" :class="isAgree ? 'active icon-dagou' : 'icon-kuang'" @click="isAgree = !isAgree"></i>
              <span @click="isAgree = !isAgree">同意</span>
              <span class="link" @click="enterToDetail('userAgreement')">《用户协议》</span>与
              <span class="link" @click="enterToDetail('privacyAgreement')">《隐私协议》</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { UserRegister, GetTelCode } from '@/api/login'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'LoginDialog',
  data() {
    return {
      phoneNumber: '',
      codeNumber: '',
      validataCodeTxt: '获取验证码',
      countDownTime: 0,
      timeOut: null,
      isLoading: false,
      isAgree: false
    }
  },
  beforeDestroy() {
    if (this.timeOut) clearInterval(this.timeOut)
  },
  computed: {
    ...mapGetters(['sessionId', 'getIsApp'])
  },
  methods: {
    ...mapMutations(['RECEIVE_SESSION_ID', 'RECEIVE_LOGIN_STATE', 'LOGINDIALOG_SHOW']),
    close() {
      this.$emit('close')
    },
    limitInput(val, type) {
      if (val === 'phone') {
        this.phoneNumber = this.phoneNumber.replace(/\D/g, '')
      } else {
        this.codeNumber = this.codeNumber.replace(/\D/g, '')
      }
      if (type === 'blur') {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 0)
      }
    },
    clearInput(val) {
      if (val === 'phone') {
        this.phoneNumber = ''
      } else {
        this.codeNumber = ''
      }
    },
    // 验证手机号
    validataPhone() {
      let phoneNumber = this.phoneNumber
      if (phoneNumber.length <= 0) {
        Toast('请输入手机号码')
        return false
      } else {
        if (!/^1[3456789][0-9]{9}$/g.test(phoneNumber)) {
          Toast('手机号码错误')
          return false
        } else {
          return true
        }
      }
    },
    // 获取验证码
    getValidateCode() {
      if (this.countDownTime) return
      let phoneNumber = this.phoneNumber
      if (this.validataPhone()) {
        this.countDownTime = 60
        Indicator.open({
          text: '加载中',
          spinnerType: 'triple-bounce'
        })
        GetTelCode({ Tel: phoneNumber })
          .then((res) => {
            if (res.Msg) {
              Toast('验证码已发送')
              this.timeOut = setInterval(this.countDown, 1000)
            }
            Indicator.close()
          })
          .catch((err) => {
            Toast(err.ErrMsg)
            this.countDownTime = 0
            Indicator.close()
          })
      }
    },
    // 倒计时
    countDown() {
      this.countDownTime = this.countDownTime - 1
      this.validataCodeTxt = this.countDownTime + 's'
      if (this.countDownTime <= 0) {
        this.validataCodeTxt = '获取验证码'
        clearInterval(this.timeOut)
      }
    },
    // 登录/注册
    login() {
      // 优先判断用户是否已勾选【同意《用户协议》&《隐私协议》】，未勾选则给出toast提示：请先阅读并同意协议
      if (!this.isAgree) {
        this.$toast('请先阅读并同意协议')
        return
      }
      if (!this.validataPhone()) return
      if (!this.codeNumber) {
        Toast('请输入验证码')
        return
      }
      if (this.codeNumber.length < 6) {
        Toast('验证码错误')
        return
      }
      let params = {
        TelCode: this.codeNumber,
        Tel: this.phoneNumber,
        Recommend: '',
        tokenid: this.sessionId
      }
      this.isLoading = true
      UserRegister(params)
        .then((res) => {
          this.RECEIVE_SESSION_ID(res.Data.tokenid)
          this.RECEIVE_LOGIN_STATE(res.Data.isLogin)
          this.$emit('close')
          if (this.getIsApp) {
            this.$EventBus.$emit('h5_register_success')
            // 注册成功通知app
            this.$uni.postMessage({
              data: {
                fetchAppInit: true,
                registerApiRes: res.Data
              }
            })
          } else {
            location.reload()
          }
          this.isLoading = false
        })
        .catch((err) => {
          this.isLoading = false
          Toast(err.ErrMsg)
        })
    },
    enterToDetail(tempRouterName) {
      this.LOGINDIALOG_SHOW(false)
      this.$router.push(tempRouterName)
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-wrapper {
  position: absolute;
  z-index: 998;
}
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 999;
}
.dialog-box {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  background: #fff;
  transform: translate3d(-50%, -50%, 0);
  width: 296px;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 16px;
  backface-visibility: hidden;
  overflow: hidden;
  z-index: 1000;
  animation: dialogAnim 0.2s ease-in;
  animation-fill-mode: backwards;
  padding: 20px 0;
  min-height: 322px;
}
.login-title {
  position: relative;
  /* line-height: 40px; */
  font-size: 18px;
  font-weight: 600;
  padding-left: 20px;
  display: flex;
  // align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.login-title .iconfont {
  /* position: absolute;
    right: 0px;
    top: 0; */
  font-size: 14px;
  width: 40px;
  /* text-align: center; */
  color: #666;
  cursor: pointer;
}
.login-input {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px 0 0;
  padding: 0 20px;
  box-sizing: border-box;
}
.login-input-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 45px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 10px;
}
.login-input-item .iconfont {
  font-size: 20px;
  color: #666;
}
.login-input-item input {
  width: 120px;
  font-size: 14px;
  height: 100%;
  margin-left: 5px;
}
.login-input-item .code-input {
  width: 200px;
  flex-grow: 1;
}
.login-input-item .input-clear {
  font-size: 13px;
  color: #bfbfbf;
  margin-left: 10px;
}
.time-tip-btn {
  position: absolute;
  right: 0;
  display: inline-block;
  font-size: 12px;
  width: 78px;
  height: 25px;
  line-height: 25px;
  border-radius: 20px;
  background: #000;
  color: #fff;
  text-align: center;
  transition: all 0.2s ease-in;
}
.time-tip-btn.cancel {
  background: #bbb;
  color: #fff;
}
.login-btn {
  width: 70%;
  height: 42px;
  line-height: 42px;
  border-radius: 30px;
  background: #000;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  font-size: 15px;
}
@keyframes dialogAnim {
  0% {
    opacity: 0;
    transform: translate3d(-50%, -50%, 0) scale(0.2);
  }
  100% {
    opacity: 1;
    transform: translate3d(-50%, -50%, 0) scale(1);
  }
}
@media screen and (max-width: 320px) {
  .login-input-item input {
    width: 84px;
  }
}
.isLoading {
  opacity: 0.6;
}
.appTitle {
  .tip {
    font-size: 14px;
    color: #a7a7a7;
  }
}
</style>
